export default __webpack_public_path__ + "static/media/intrvl_name_logo_black.9f431a2b.svg";